import createCachedSelector, { LruObjectCache } from 're-reselect';

import { isCurrentUser, getUserFirstName, getUserLastName } from 'selectors/user/selector';
import { getTranslation } from 'pages/utils/page-utils';

// Example name: Victor Malchikov
const FIRST_LAST_ONLY = 'firstLastOnly'; // Victor Malchikov
const FIRST_LAST = 'firstLast'; // Victor Malchikov (Me)
const INITIALS = 'initials'; // VM

function formatName(firstName = '', lastName = '', format = FIRST_LAST_ONLY, isCurrent = false) {
  let formattedName = '';
  switch (format) {
    case FIRST_LAST_ONLY:
      formattedName = `${firstName} ${lastName}`;
      break;
    case FIRST_LAST: {
      const name = `${firstName} ${lastName}`;
      formattedName = isCurrent === true ? `${name} (${getTranslation('common.me')})` : name;
      break;
    }
    case INITIALS: {
      const firstNameInitial = firstName.charAt(0).toUpperCase();
      const lastNameInitial = lastName.charAt(0).toUpperCase();
      formattedName = `${firstNameInitial}${lastNameInitial}`;
      break;
    }
    default:
      formattedName = '';
  }

  return `${formattedName.trim()}`;
}

const selectedFormat = ({ format }) => format;

const getFormattedName = createCachedSelector(
  getUserFirstName,
  getUserLastName,
  isCurrentUser,
  selectedFormat,
  (firstName, lastName, isCurrent, format) => formatName(firstName, lastName, format, isCurrent)
)(props => `getFormattedName:${props.user.email}:${props.user.firstName}:${props.user.lastName}:${props.format}`, {
  cacheObject: new LruObjectCache({ cacheSize: 100 })
});

function clearAllCache() {
  getFormattedName.clearCache();
}

export { FIRST_LAST_ONLY, FIRST_LAST, INITIALS, clearAllCache, getFormattedName };
